module.exports = __webpack_public_path__ + "img/album08_04.a8b883bd.jpg";